import styled from "styled-components";

export const StyledSlideProductDiv = styled.div`
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 1px -1px,
    rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px;
  width: 100%;
  padding: 10px;
  position: relative;
  & img {
    border-radius: 4px;
  }
  & h2 {
    font-size: 15px;
    font-weight: 300;
    line-height: 2.17;
    color: #41464f;
    height: 52px;
    overflow: hidden;
    text-align: right;
    direction: rtl;
    margin-top: 2px;
  }

  & p {
    margin: 0;
    text-align: left;
    color: #41464f;
    font-size: 17px;
    direction: rtl;
    & span:nth-child(2) {
      font-size: 12px;
    }
  }
  .product-p {
    text-decoration: line-through !important;
    color: #bdc0c4;
  }
`;